import Link from '../../views/Register';
import { connect } from 'react-redux';
import { actions } from '../../../state/auth';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    register: (firstname, lastname, email, telephone) =>
      dispatch(actions.register(firstname, lastname, email, telephone)).then(
        () => dispatch(push(`/${locale}/signupsuccess`))
      )
  };
};

const Register = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Register;



// WEBPACK FOOTER //
// ./src/components/container/Register/index.js